import { createParser } from 'nuqs'

export const PERMISSION_OPTIONS = ['team', 'user', 'company', 'role'] as const

export type PermissionOption = (typeof PERMISSION_OPTIONS)[number]

export const parseAsPermissionOption = createParser({
  parse(queryValue) {
    const decoded = decodeURIComponent(queryValue)
    if (isPermissionOption(decoded)) {
      return decoded
    }
    return null
  },
  serialize(value) {
    return encodeURIComponent(value)
  },
})

export const isPermissionOption = (value: unknown): value is PermissionOption => {
  return typeof value === 'string' && PERMISSION_OPTIONS.some((option) => option === value)
}
